export default __webpack_public_path__ + "static/media/user.baaa8a15.svg";